import React from 'react';
import { motion } from 'framer-motion';
import { 
  IconCode, 
  IconMobile, 
  IconDatabase, 
  IconRocket, 
  IconArrowDown 
} from './icons';

const Hero: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1
    }
  };

  const skills = [
    { icon: IconCode, label: 'Desarrollo Web', color: 'text-blue-600' },
    { icon: IconMobile, label: 'Apps iOS', color: 'text-green-600' },
    { icon: IconDatabase, label: 'Bases de Datos', color: 'text-purple-600' },
    { icon: IconRocket, label: 'Startups', color: 'text-red-600' }
  ];

  return (
    <section id="home" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 pt-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="text-center max-w-4xl mx-auto"
        >
          {/* Main Title */}
          <motion.h1
            variants={itemVariants}
            className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-6"
          >
            <span className="gradient-text">Fernando Javier</span>
            <br />
            <span className="text-gray-800">Pinilla Barrena</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            variants={itemVariants}
            className="text-xl sm:text-2xl text-gray-600 mb-8 font-medium"
          >
            Desarrollador de Software & Emprendedor
          </motion.p>

          {/* Description */}
          <motion.p
            variants={itemVariants}
            className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto leading-relaxed"
          >
            Especializado en desarrollo de aplicaciones iOS, software a medida y soluciones web. 
            Fundador de <span className="font-semibold text-primary-600">Synapse</span> y{' '}
            <span className="font-semibold text-primary-600">Creapptiva</span>, con más de 15 años de experiencia 
            llevando ideas digitales a la realidad.
          </motion.p>

          {/* Skills Grid */}
          <motion.div
            variants={itemVariants}
            className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12"
          >
            {skills.map((skill, index) => (
              <motion.div
                key={skill.label}
                whileHover={{ scale: 1.05 }}
                className="bg-white rounded-xl p-6 shadow-sm border border-gray-200"
              >
                <skill.icon className={`text-3xl ${skill.color} mb-3 mx-auto`} />
                <p className="text-sm font-medium text-gray-700">{skill.label}</p>
              </motion.div>
            ))}
          </motion.div>

          {/* CTA Buttons */}
          <motion.div
            variants={itemVariants}
            className="flex flex-col sm:flex-row gap-4 justify-center mb-16"
          >
            <a
              href="#projects"
              className="btn-primary text-center px-8 py-3"
            >
              Ver Proyectos
            </a>
            <a
              href="#contact"
              className="btn-secondary text-center px-8 py-3"
            >
              Contactar
            </a>
          </motion.div>

          {/* Scroll Indicator */}
          <motion.div
            variants={itemVariants}
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 2 }}
            className="text-gray-400"
          >
            <a href="#about" className="inline-block">
              <IconArrowDown size={24} />
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;